import { useOrganisationMembers } from '@/hooks/useOrganisations';
import { useAuthStore } from '@/store/auth.store';
import { useOrganisationsStore } from '@/store/organisations.store';
import { OrganisationRole } from '@/types/organisation.types';

const ROLE_HIERARCHY: Record<OrganisationRole, number> = {
  owner: 4,
  admin: 3,
  member: 2,
  viewer: 1,
};

export const useCurrentMemberRole = () => {
  const { user } = useAuthStore();
  const { currentOrganisation } = useOrganisationsStore();
  const { data: orgMembers } = useOrganisationMembers(currentOrganisation?.uuid || '');

  const currentMember = orgMembers?.find(
    (m) => m.userUuid === user?.id || m.user?.uuid === user?.id
  );

  const role = currentMember?.role ?? null;
  const isAdmin = !!role && ROLE_HIERARCHY[role] >= ROLE_HIERARCHY['admin'];
  const isOwner = role === 'owner';

  return { role, isAdmin, isOwner, currentMember };
};
